import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, mergeProps as _mergeProps, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36aa755a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Firms", -1))
const _hoisted_2 = { class: "api-key" }

import EditableDataGrid from '@/components/EditableDataGrid.vue'

	import { defineComponent, Ref, ref } from 'vue';
	import { AreaOfLaw } from '@/interfaces/AreaOfLaw';
	import { ZipCode } from '@/interfaces/ZipCode';
	import { LawFirm } from '@/interfaces/LawFirm'
	import DeleteConfirmationForm from '@/components/DeleteConfirmationForm.vue'
	import { GridColumn } from '@/interfaces/Grid';
	import { FormatterService } from '@/services/FormatterService'
	import { copyText } from '@/services/Utils'
	interface FirmGridColumn extends GridColumn {
		to?: null | string,
	}
	interface Data {
		headers: Array<FirmGridColumn>,
	}
	const __default__ = defineComponent({
		name: 'FirmsView',
		data(): Data {
			return {
				headers: [
					{
						title: 'ID',
						sortable: true,
						key: 'id',
						align: 'end',
						width: '50px',
					},
					{ title: 'Name', key: 'name', align: 'start', to: "/firms/{id}" },
					{
						title: 'Areas', key: 'areasOfLaw', sortable: false, align: 'start', formatter: (value: AreaOfLaw[]) => {
							const initial = '';
							return value?.reduce((accumulator, current) => `${accumulator}${accumulator ? ', ' : ''}${current.name}`, initial) ?? '';
						}
					},
					{
						title: 'Zip Codes', key: 'zipCodes', sortable: false, align: 'start', formatter: (value: ZipCode[]) => {
							const initial = '';
							return value?.reduce((accumulator, current) => `${accumulator}${accumulator ? ', ' : ''}${current.code}`, initial) ?? '';
						}
					},
					{ title: 'Create date', key: 'createDate', align: 'start', formatter: FormatterService.defaultDate() },
					{ title: 'Update', key: 'updateDate', align: 'start', formatter: FormatterService.defaultDate() },
					{ title: 'Actions', key: 'actions', sortable: false, align: 'end', width: '100px' },
				],
			}
		},
		methods: {
		}
	})


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

	
return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_hover = _resolveComponent("v-hover")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_row, { class: "mb-2" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, null, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { class: "text-right" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              color: "indigo-darken-3",
              variant: "flat",
              to: "/firms/0"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" New Firm ")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(EditableDataGrid, {
      propHeaders: _ctx.headers,
      propController: 'lawfirm',
      propEditForm: null,
      propDeleteForm: DeleteConfirmationForm
    }, {
      cellTemplate: _withCtx(({ header, item, formatCell, deleteItem }) => [
        (header.key == 'name')
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: header.to.replace('{id}', item.raw.id)
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(formatCell(header, item.raw[header.key])), 1)
              ]),
              _: 2
            }, 1032, ["to"]))
          : (header.key == 'apiKey')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (item.raw[header.key])
                  ? (_openBlock(), _createBlock(_component_v_hover, { key: 0 }, {
                      default: _withCtx(({ isHovering, props }) => [
                        _createVNode(_component_v_icon, _mergeProps({ size: "x-small" }, props, {
                          color: isHovering ? 'info' : '',
                          onClick: ($event: any) => (_unref(copyText)(`${item.raw[header.key]}`))
                        }), {
                          default: _withCtx(() => [
                            _createTextVNode(" mdi-content-copy ")
                          ]),
                          _: 2
                        }, 1040, ["color", "onClick"])
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_2, _toDisplayString(formatCell(header, item.raw[header.key])), 1)
              ], 64))
            : (header.key == 'actions')
              ? (_openBlock(), _createBlock(_component_v_icon, {
                  key: 2,
                  size: "small",
                  onClick: ($event: any) => (deleteItem(item.raw))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" mdi-delete ")
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  _createTextVNode(_toDisplayString(formatCell(header, item.raw[header.key])), 1)
                ], 64))
      ]),
      _: 1
    }, 8, ["propHeaders"])
  ], 64))
}
}

})